module.exports = __webpack_public_path__ + "static/img/head-pic@2x.5f056dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/head-pic@2x.png
// module id = eGjY
// module chunks = 1